import React, { useMemo, useState, useContext } from 'react'
import { Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import { KPI } from 'src/mtska-frontend-app-component';
import { useSettingsContext } from 'src/mtska-frontend-app-scaffolding';

const dataProviderName = 'cars/car';

const mergeKpiFilters = (baseFilters, extraItems = []) => ({
    items: [...(baseFilters?.items ?? []), ...extraItems],
});

const FleetManagerCarKPI = ({ filters, setFilters, userCapabilities }) => {
    const { t } = useTranslation();
    const { addFilter } = useSettingsContext(dataProviderName);

    return useMemo(() => <>
        <Box className="mtska-chart-wrapper">
            <KPI
                title="running"
                icon="faCar"
                dataProviderName={'statisticsviews/running/count/cars/car'}
                filterbutton={{
                    visible: true,
                    label: t("View"),
                    callback: () => { addFilter("status", "running", "equals") }
                }}
                filters={mergeKpiFilters(filters, [{
                    field: "status",
                    operator: "equals",
                    value: "running"
                }])}
            />
            <KPI
                title="in_order"
                icon="faCartShopping"
                dataProviderName={'statisticsviews/order/count/cars/car'}
                filterbutton={{
                    visible: true,
                    label: t("View"),
                    callback: () => { addFilter("status", "in_order", "equals") }
                }}
                filters={mergeKpiFilters(filters, [{
                    field: "status",
                    operator: "equals",
                    value: "in_order"
                }])}
            />
            <KPI
                title="closed"
                icon="faFolder"
                dataProviderName={'statisticsviews/closed/count/cars/car'}
                filterbutton={{
                    visible: true,
                    label: t("View"),
                    callback: () => { addFilter("status", "closed", "equals") }
                }}
                filters={mergeKpiFilters(filters, [{
                    field: "status",
                    operator: "equals",
                    value: "closed"
                }])}
            />
            <KPI
                title="canceled"
                icon="faTrash"
                dataProviderName={'statisticsviews/closed/count/cars/car'}
                filterbutton={{
                    visible: true,
                    label: t("View"),
                    callback: () => { addFilter("status", "canceled", "equals") }
                }}
                filters={mergeKpiFilters(filters, [{
                    field: "status",
                    operator: "equals",
                    value: "canceled"
                }])}
            />
            <KPI
                title="Total"
                icon="faCars"
                dataProviderName={'statisticsviews/item/count/cars/car'}
                filters={filters}
            />
        </Box>
    </>, [filters])

}

export default FleetManagerCarKPI;


